import { Field, Select } from '@noorden-insurtech/alba-design-system';

export type SegmentOption = {
  value: string;
  label: string;
};

type Props = {
  value: string;
  onChange: (value: string, label?: string) => void;
  selectedLabel?: string;
  options?: SegmentOption[];
  useSelect?: boolean;
  isLoading?: boolean;
  required?: boolean;
  error?: string;
  disabled?: boolean;
};

export function SegmentSelect({
  value,
  onChange,
  selectedLabel,
  options,
  useSelect,
  isLoading,
  required,
  error,
  disabled,
}: Props) {
  if (useSelect) {
    const rawItems = options ?? [];
    const hasSelectedItem = rawItems.some(item => item.value === value);
    const items =
      value && selectedLabel && !hasSelectedItem
        ? [{ value, label: selectedLabel }, ...rawItems]
        : rawItems;

    return (
      <Field.Root invalid={!!error}>
        <Field.Label className='text-sm font-bold text-alba-black-500'>
          Segmento
          {required && <span className='text-alba-error-red-500'>*</span>}
        </Field.Label>
        <Select.Root
          value={value ? [value] : []}
          onValueChange={details => {
            const selectedValue = details.value[0] || '';
            const selectedOption = items.find(
              item => item.value === selectedValue
            );
            onChange(selectedValue, selectedOption?.label);
          }}
          positioning={{ sameWidth: true }}
          items={items}
          disabled={disabled || isLoading}
        >
          <Select.Control>
            <Select.Trigger>
              <Select.ValueText
                placeholder={
                  isLoading ? 'Carregando segmentos...' : 'Selecione o segmento'
                }
              />
              <Select.Indicator />
            </Select.Trigger>
          </Select.Control>
          <Select.Positioner>
            <Select.Content>
              {items.map(option => (
                <Select.Item key={option.value} item={option}>
                  <Select.ItemText>{option.label}</Select.ItemText>
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Positioner>
        </Select.Root>
        {error && <Field.ErrorText>{error}</Field.ErrorText>}
      </Field.Root>
    );
  }

  return (
    <Field.Root invalid={!!error}>
      <Field.Label className='text-sm font-bold text-alba-black-500'>
        Segmento
        {required && <span className='text-alba-error-red-500'>*</span>}
      </Field.Label>
      <Field.Input
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder='Digite o segmento'
        disabled={disabled}
      />
      {error && <Field.ErrorText>{error}</Field.ErrorText>}
    </Field.Root>
  );
}
